export default __webpack_public_path__ + "0c37ef2d8470b96a92a5648f6677bb10.png";